import { PROCESS_STEPS } from "../../data/content";

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 lg:py-36 border-t border-white/5 scroll-mt-24" data-testid="how-it-works-section">
      <div className="container-x">
        <p className="section-label">HOW IT WORKS</p>
        <h2 className="mt-5 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white max-w-3xl">
          NINE STEPS. <span className="text-flame">ZERO DRIFT.</span>
        </h2>
        <p className="mt-6 text-slate-400 max-w-2xl leading-relaxed">
          Every engagement follows the same disciplined path — so you always know exactly where your software stands.
        </p>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PROCESS_STEPS.map((s) => (
            <div key={s.step} data-testid={`process-step-${s.step}`} className="relative rounded-2xl border border-white/10 bg-navy-800 p-8 card-lift">
              <p className="font-mono text-3xl font-bold text-flame/30">{s.step}</p>
              <h3 className="mt-3 font-heading text-lg font-bold tracking-wide text-white">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-400">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
